import React, { useEffect, useState } from 'react';
import { func, number, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { hydrateCart, selectCartCount } from '../../ducks/cart.duck';

import css from './CartCountBadge.module.css';

/**
 * CartCountBadge
 *
 * Small counter shown over the header basket icon. It also hydrates the basket
 * from localStorage on mount (the store starts empty for SSR determinism, so
 * the persisted basket is merged in on the client). The count is only rendered
 * after mount to avoid a server/client hydration mismatch.
 */
export const CartCountBadgeComponent = props => {
  const { className, count = 0, onHydrateCart } = props;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    onHydrateCart();
    setMounted(true);
  }, [onHydrateCart]);

  if (!mounted || count <= 0) {
    return null;
  }

  const label = count > 99 ? '99+' : `${count}`;
  return <span className={classNames(css.badge, className)}>{label}</span>;
};

CartCountBadgeComponent.propTypes = {
  className: string,
  count: number,
  onHydrateCart: func.isRequired,
};

const mapStateToProps = state => ({
  count: selectCartCount(state),
});

const mapDispatchToProps = dispatch => ({
  onHydrateCart: () => dispatch(hydrateCart()),
});

const CartCountBadge = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CartCountBadgeComponent);

export default CartCountBadge;
